import { CssBaseline, createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import { Navigate, Outlet, Route, Routes } from "react-router";
import { setUpAxios } from "@entrilia/shared/api/axiosHelper";
import LoggedOut from "@entrilia/shared/auth/LoggedOut";
import LogoutContainer from "@entrilia/shared/auth/b2c/LogoutContainer";
import SignUp from "@entrilia/shared/auth/b2c/SignUp";
import { handleB2CRedirectUrlState } from "@entrilia/shared/auth/b2c/redirects";
import Error from "@entrilia/shared/components/Error";
import { Licenses } from "@entrilia/shared/licensing";
import { initAppInsights } from "@entrilia/shared/logging";
import { lightThemeOptions } from "@entrilia/shared/theme";
import App, { placeholderClientParam } from "./App";
import Authentication from "./auth/Authentication";
import { redirectToB2CAuthWithImpersonation } from "./impersonation/impersonationAuth";
import { handlePortalImpersonation } from "./impersonation/impersonationHandler";
import { setAuthMode } from "./variables";
import "./lp.css";

LicenseInfo.setLicenseKey(Licenses.MUI_X_PREMIUM_KEY);

const handled = handleB2CRedirectUrlState(() => setAuthMode("end_user"));

if (!handled) {
  initAppInsights({ appId: "InvestorPortal" });
  handlePortalImpersonation();
  setUpAxios(redirectToB2CAuthWithImpersonation);
}

const theme = createTheme(lightThemeOptions);

const Entry = () => {
  if (handled) {
    return <></>;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/oauth" element={<Authentication />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/:client/*" element={<Outlet />}>
          <Route path="loggedout" element={<LoggedOut href="./" />} />
          <Route path="loggedoutImpersonation" element={<LoggedOut hideLoginRedirectButton={true} href="./" />} />
          <Route path="logout" element={<LogoutContainer />} />
          <Route path="*" element={<App />} />
        </Route>
        <Route path="/error" element={<Error />} />
        <Route path="" element={<Navigate to={`/${placeholderClientParam}`} />} />
      </Routes>
    </ThemeProvider>
  );
};

export default Entry;
